export const UPLOAD_ORDERS_STEPS = ['Subir plantilla', 'Resumen'];

export const UPLOAD_ORDERS_MODAL_TEXT = {
  description:
    'Estás por realizar un reemplazo de las órdenes, solo quedarán prendidos los productos que estás cargando. ¿Seguro que deseas continuar?',
  firstButtonText: 'No, cancelar',
  secondButtonText: 'Sí, reemplazar órdenes'
};
